import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useUpdateUserGroupMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IUserGroup) => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ userGroup }: { userGroup: Api.IUserGroup }) => {
			return userSession.webServiceHelper.callAsync<Api.IUserGroup>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `userGroup/${userGroup.id}`,
				}),
				'PUT',
				userGroup
			);
		},
		onError,
		onSuccess,
	});
}
